module.exports = __webpack_public_path__ + "static/media/Lab_Partner_4_PCR_Product.035a1ba2.svg";